import { ThemeProvider } from '@mui/material/styles';
import { defaultTheme, formatDateNoTime } from '../utilities/Utilites';
import * as React from 'react';
import Box from '@mui/system/Box';
import { Card, Grid } from '@mui/material';
import { useGlobalStore } from '../utilities/GlobalState';
import { SalesOrder } from '../interfaces/Interfaces';
import { AuthGet } from '../utilities/Routing/Requests';
import { DateTime } from 'luxon';
import { Datagrid } from '../utilities/Datagrid';

export const OrderPage = () => {
    const [salesOrders, setSalesOrders] = React.useState<Array<SalesOrder>>([]);
    const globalState = useGlobalStore((state) => state);
    React.useEffect(() => {
        AuthGet('/GetSODetails', {
            showClosed: false,
            canCache: true,
            'x-access-token': globalState?.authToken,
            customer: globalState?.customerId,
        }).then((res) => {
            let data;
            if (res?.data?.length) {
                const shippedRemoved = res?.data?.filter(
                    (so: SalesOrder) =>
                        so?.status?.toLowerCase() !== 'shipped' &&
                        so?.status?.toLowerCase() !== 'closed',
                );
                if (shippedRemoved?.length) {
                    data = shippedRemoved?.sort(
                        (a: SalesOrder, b: SalesOrder) => {
                            if (
                                a.sales_Order.toUpperCase() <
                                b.sales_Order.toUpperCase()
                            ) {
                                return -1;
                            }
                            if (
                                a.sales_Order.toUpperCase() >
                                b.sales_Order.toUpperCase()
                            ) {
                                return 1;
                            }
                            if (
                                a.sales_Order.toUpperCase() ===
                                b.sales_Order.toUpperCase()
                            ) {
                                if (
                                    a.customer_PO_Line &&
                                    b.customer_PO_Line &&
                                    Number(a.customer_PO_Line) <
                                        Number(b.customer_PO_Line)
                                ) {
                                    return -1;
                                }
                                if (
                                    a.customer_PO_Line &&
                                    b.customer_PO_Line &&
                                    Number(a?.customer_PO_Line) >
                                        Number(b?.customer_PO_Line)
                                ) {
                                    return 1;
                                }
                            }
                            return 0;
                        },
                    );
                }
            }
            setSalesOrders(data);
        });
    }, []);

    const address = (row: SalesOrder) => {
        let newAddressString = '';
        if (row?.name) {
            newAddressString = newAddressString?.length
                ? newAddressString + ' ' + row.name.trim() + ','
                : newAddressString + row.name.trim() + ',';
        }
        if (row?.line1) {
            newAddressString = newAddressString?.length
                ? newAddressString + ' ' + row.line1
                : newAddressString + row.line1;
        }
        if (row?.line2) {
            newAddressString = newAddressString?.length
                ? newAddressString + ' ' + row.line2
                : newAddressString + row.line2;
        }
        if (row?.city) {
            newAddressString = newAddressString?.length
                ? newAddressString + ' ' + row.city
                : newAddressString + row.line1;
        }
        if (row?.state) {
            newAddressString = newAddressString + ', ' + row.state;
        }
        if (row?.zip) {
            newAddressString = newAddressString + ' ' + row.zip;
        }
        return newAddressString;
    };

    const getRowId = (row: any) => {
        return row.objectID;
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Box
                sx={{
                    padding: '30px 10px 10px 10px',
                    maxWidth: '100vp',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Card sx={{ padding: '10px', margin: '10px' }}>
                    <Grid
                        container
                        style={{
                            padding: '10px 10px 10px 20px',
                            backgroundColor: '#f44336',
                            color: '#fff',
                            fontWeight: 'bold',
                            fontSize: '20px',
                        }}
                    >
                        <Grid item>
                            <div>Order Information</div>
                        </Grid>
                    </Grid>

                    {Datagrid({
                        getRowId: getRowId,
                        pageSize: 20,
                        columns: [
                            {
                                field: 'sales_Order',
                                headerName: 'APT Order',
                                type: 'string',
                                flex: 0.5,
                            },
                            {
                                field: 'material',
                                headerName: 'Part',
                                type: 'string',
                                flex: 0.8,
                            },
                            {
                                field: 'customer_PO',
                                headerName: 'PO',
                                type: 'string',
                                flex: 0.25,
                            },
                            {
                                field: 'customer_PO_Line',
                                headerName: 'Line',
                                type: 'string',
                                flex: 0.25,
                            },
                            {
                                field: 'adjusted_Promise_Date',
                                headerName: 'Anticipated Ship Date',
                                type: 'string',
                                flex: 0.5,
                                renderCell: (params) => {
                                    return (
                                        <div>
                                            {formatDateNoTime(
                                                DateTime.fromISO(
                                                    params?.row
                                                        ?.adjusted_Promise_Date,
                                                    { zone: 'utc' },
                                                ),
                                            )}
                                        </div>
                                    );
                                },
                            },
                            {
                                field: 'Address',
                                headerName: 'Delivery Address',
                                type: 'string',
                                flex: 1.5,
                                renderCell: (params) => {
                                    return <div>{address(params?.row)}</div>;
                                },
                            },
                        ],
                        data: salesOrders,
                    })}
                </Card>
            </Box>
        </ThemeProvider>
    );
};
